// extracted by mini-css-extract-plugin
export default {"formItemLabel":"details_formItemLabel__OwKY-","selectedTag":"details_selectedTag__JwMNp","categoryDivider":"details_categoryDivider__XCg30"};